import { globalRefiningGroupName } from '../constants/companies/globalRefiningGroup';

function isGlobalRefiningGroup(value) {
  return value === globalRefiningGroupName;
}

export { isGlobalRefiningGroup };
